$(function() {
  $('#js-update-note-modal').modal('show');
});
